/*
  Cart-context quick-add drawer behavior.
  Extracted 2026-09-01 from the inline <script> in
  snippets/cart-upsell-quick-add-drawer.liquid (verbatim, zero Liquid).

  Loaded `defer` from that snippet. Self-guarded via
  window.__neswCartUpsellDrawerMounted so a double-render of the
  snippet (cart-drawer.liquid + cart-section.liquid both include it)
  stays safe — the second load is a no-op.
*/
(function () {
  if (window.__neswCartUpsellDrawerMounted) return;
  window.__neswCartUpsellDrawerMounted = true;

  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }

  function inCartContext(el) {
    return !!(el && el.closest && (
      el.closest('.cart-drawer-upsell-wrap') ||
      el.closest('.cart-page-upsell-wrap')
    ));
  }

  var drawer = document.getElementById('cuq-drawer');
  if (!drawer) return;
  var imgEl   = document.getElementById('cuq-product-image');
  var titleEl = document.getElementById('cuq-product-title');
  var colorEl = document.getElementById('cuq-product-variant');
  var priceEl = document.getElementById('cuq-product-price');
  var sizesEl = document.getElementById('cuq-sizes-list');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    /* Do not hand scrolling back if the cart drawer is still open behind this
       sheet: it set the lock and expects to keep it. Now that adding from Pair
       It With leaves the drawer open, clearing it here let the page scroll
       underneath an open cart. */
    var __cd = document.getElementById('cart-drawer');
    document.body.style.overflow = (__cd && __cd.classList.contains('open')) ? 'hidden' : '';
  }

  drawer.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-cuq-close]')) closeDrawer();
  });

  /* V2 — Look up the correct variant id for a (color, size) pair.
     The inline `.related-size-btn`s only carry the FIRST-color variant
     id for each size — picking the secondary color + a size used to
     add the primary color's variant. `related-product-card.liquid`
     now emits `data-variants` on the card root with every (id, color,
     size, available) tuple. If that exists, prefer it over the size
     button's baked-in `data-variant-id`. */
  function resolveVariantIdForColorSize(card, activeColor, sizeLabel, fallbackId) {
    if (!card || !activeColor) return fallbackId;
    var raw = card.getAttribute && card.getAttribute('data-variants');
    if (!raw) return fallbackId;
    try {
      var variants = JSON.parse(raw);
      var ac = (activeColor || '').toString().trim();
      var sl = (sizeLabel || '').toString().trim();
      var match = variants.find(function (v) {
        return (v.color || '').toString().trim() === ac &&
               (v.size || '').toString().trim() === sl;
      });
      /* V2 — Color-only fallback. Products whose only real option is
         Color (e.g. the Core Hat: Black/White, "Accessory size" is a
         constant "One size") render a single "Add To Bag" pill whose
         label is NOT a real size, so the exact (color,size) match above
         fails and we'd otherwise return the FIRST variant — adding Black
         when the customer picked White. When there's an active color,
         fall back to matching that color alone. */
      if (!match) {
        match = variants.find(function (v) {
          return (v.color || '').toString().trim() === ac;
        });
      }
      if (match && match.id) return String(match.id);
    } catch (_) {}
    return fallbackId;
  }

  /* Build size rows from the inline `.related-size-btn`s. DOM-only
     construction (createElement + textContent / dataset) — no innerHTML
     — so labels/variant ids can never be interpreted as markup. */
  function buildRowsInto(parent, sizeButtons, card, activeColor) {
    var seen = Object.create(null);
    sizeButtons.forEach(function (b) {
      var label = (b.textContent || '').trim();
      if (!label) return;
      if (seen[label]) return;
      seen[label] = true;
      var variantId  = b.dataset.variantId || '';
      var disabled   = b.disabled || b.classList.contains('unavailable');
      var isAddToBag = b.classList.contains('related-add-to-bag-btn');
      var displaySize = isAddToBag ? 'One Size' : label;

      var row = document.createElement('div');
      row.className = 'cuq-size-row';

      var nameEl = document.createElement('span');
      nameEl.className = 'cuq-size-name' + (disabled ? ' unavailable' : '');
      nameEl.textContent = displaySize;
      row.appendChild(nameEl);

      if (disabled) {
        var sold = document.createElement('span');
        sold.className = 'cuq-sold';
        sold.textContent = 'Sold Out';
        row.appendChild(sold);
      } else {
        var addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'cuq-add';
        /* Prefer the (activeColor, size) variant from the card's
           variant matrix; falls back to the size button's baked-in
           id when no color is active or no matrix is present. */
        var resolvedId = resolveVariantIdForColorSize(card, activeColor, label, variantId);
        addBtn.dataset.variantId = resolvedId;
        addBtn.textContent = 'Add to bag';
        row.appendChild(addBtn);
      }
      parent.appendChild(row);
    });
  }

  function fillFromCard(card) {
    var titleA = card.querySelector('.related-product-title');
    var priceEl2 = card.querySelector('.related-product-price');
    var currentColorEl = card.querySelector('.related-current-color');
    var activeSwatch = card.querySelector('.related-color-swatch.active');
    var primaryImg = card.querySelector('.related-product-img-primary');

    var src = (activeSwatch && activeSwatch.dataset.image) ||
              (primaryImg && primaryImg.currentSrc) ||
              (primaryImg && primaryImg.src) || '';
    /* V2 — Hide-during-swap so the previous product's cached raster
       doesn't flash through. Preloader keeps cache warm; this just
       handles the cache-miss case cleanly. */
    imgEl.style.transition = 'opacity 0.12s ease';
    imgEl.style.opacity = '0';
    function __cuqReveal() { imgEl.style.opacity = '1'; }
    imgEl.onload = __cuqReveal;
    imgEl.onerror = __cuqReveal;
    imgEl.src = src;
    imgEl.alt = (titleA && titleA.textContent.trim()) || '';
    if (imgEl.complete && imgEl.naturalWidth > 0) __cuqReveal();

    titleEl.textContent = (titleA && titleA.textContent.trim()) || '';
    var activeColor = activeSwatch ? (activeSwatch.dataset.color || '').trim() : '';
    var color = activeColor || (currentColorEl ? currentColorEl.textContent.trim() : '');
    colorEl.textContent = color;
    colorEl.style.display = color ? '' : 'none';
    /* V2 — Copy the price HTML, not textContent, so a sale item's struck
       pre-sale price + discounted price (the nesw-sale-price markup:
       .nesw-price__now + <s class="nesw-price__was">) renders here too.
       textContent flattened it to "$78$88" with no strike-through. The
       .nesw-price styles are global (layout/theme.liquid). */
    if (priceEl2) priceEl.innerHTML = priceEl2.innerHTML;
    else priceEl.textContent = '';

    /* Filter the size buttons to the active swatch's color. The strip
       contains every (color, size) variant pre-rendered; without this
       filter you'd see every size from every color mashed together. */
    var inlineSel = card.querySelector('.related-size-selector');
    var sizeBtns = inlineSel ? Array.from(inlineSel.querySelectorAll('.related-size-btn')) : [];
    if (activeColor) {
      var filtered = sizeBtns.filter(function (b) {
        var c = (b.dataset.color || '').trim();
        return !c || c === activeColor;
      });
      if (filtered.length) sizeBtns = filtered;
    }
    while (sizesEl.firstChild) sizesEl.removeChild(sizesEl.firstChild);
    buildRowsInto(sizesEl, sizeBtns, card, activeColor);
  }

  /* ──────── Swatch click handler (cart upsell) ────────
     PDP related-products has its own swatch handler (scoped to that
     section's container element), so it never bound in cart contexts.
     Without this, tapping a swatch on a cart upsell card did
     literally nothing. Mirrors the PDP handler's behavior: swap the
     card's primary image, swap the visible color name, mark the new
     swatch active. The drawer then reads the new active swatch when
     it opens (see `fillFromCard` above), so picking a color → tapping
     bag picks the right variant. */
  document.addEventListener('click', function (e) {
    var swatch = e.target && e.target.closest && e.target.closest('.related-color-swatch');
    if (!swatch) return;
    if (!inCartContext(swatch)) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.product-recommendations-card');
    if (!card) return;
    var color = (swatch.dataset.color || '').trim();
    var image = swatch.dataset.image || '';

    /* Active state — clear siblings, mark this one. */
    card.querySelectorAll('.related-color-swatch').forEach(function (s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');

    /* Image swap. Browsers preload the swatch's `data-image` lazily;
       a quick opacity dip masks the small load delay if it's first
       paint, instantaneous if cached. */
    var img = card.querySelector('.related-product-img-primary');
    if (img && image) {
      img.style.transition = 'opacity 0.12s ease';
      img.style.opacity = '0.65';
      var newImg = new Image();
      newImg.onload = function () {
        img.src = image;
        img.style.opacity = '1';
      };
      newImg.onerror = function () { img.style.opacity = '1'; };
      newImg.src = image;
    }

    /* Color name in the "Black · 3 Colors" line. */
    var colorNameEl = card.querySelector('.related-current-color');
    if (colorNameEl && color) colorNameEl.textContent = color;
  }, true);

  /* Tap the bag icon on a cart-upsell card → open the drawer. Used
     to be mobile-only via an `isMobile()` short-circuit, but Jay
     flagged that desktop clicks did nothing (no PDP `related-products`
     section is on the cart page or in the drawer to handle clicks),
     so the bag was effectively dead. Opening the drawer on every
     viewport now; desktop gets a centered modal via the responsive
     CSS in the snippet's `@media (min-width: 769px)` block. Capture
     phase so we beat the `.related-size-selector` hover/toggle CSS. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.related-quick-add-btn');
    if (!btn) return;
    /* Cart contexts (drawer + cart page): open on every viewport (existing).
       PDP "Pair It With": on MOBILE, open this same bottom-sheet popup so
       every quick-add matches the cart drawer's. On desktop the PDP keeps its
       inline hover overlay (related-products.liquid handles it), so bail out
       there. The PDP related cards are the SAME `related-product-card` snippet,
       so fillFromCard reads them identically. */
    if (!inCartContext(btn) && !isMobile()) return;

    var card = btn.closest('.product-recommendations-card');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();
    fillFromCard(card);
    openDrawer();
  }, true);

  /* Drawer's Add to bag → /cart/add.js, refresh cart drawer + cart
     page in place (no full reload), then close. */
  document.addEventListener('click', function (e) {
    var addBtn = e.target && e.target.closest && e.target.closest('.cuq-add');
    if (!addBtn) return;
    if (!drawer.classList.contains('is-open')) return;
    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;
    if (addBtn.classList.contains('adding')) return;

    e.preventDefault();
    addBtn.classList.add('adding');
    var originalText = addBtn.textContent;
    addBtn.textContent = 'Adding…';

    /* Canonical add (fires Meta AddToCart + reconciles /cart.js + cart:change). */
    window.neswAddToCart(variantId, 1)
      .then(function () {
        addBtn.classList.remove('adding');
        addBtn.classList.add('added');
        addBtn.textContent = 'Added';

        /* V2 — Jay: bring the cart to the TOP after adding so the new item
           (which now renders newest-first at the top) is in view. The drawer's
           updateCart honours this flag once it finishes re-rendering. */
        window.__neswScrollCartTopAfterUpdate = true;

        /* Re-render whatever cart surface is on the page. Both are no-reload:
           drawer re-renders line items from /cart.js, page uses the Section
           Rendering API to swap items + footer. */
        if (typeof window.updateCart === 'function') {
          try { window.updateCart(); } catch (_) {}
        }
        if (typeof window.refreshCartPage === 'function') {
          try { window.refreshCartPage(); } catch (_) {}
        }

        setTimeout(function () {
          closeDrawer();
          addBtn.classList.remove('added');
          addBtn.textContent = originalText;
        }, 700);
      })
      .catch(function () {
        addBtn.classList.remove('adding');
        addBtn.textContent = 'Try Again';
        setTimeout(function () { addBtn.textContent = originalText; }, 1500);
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* V2 — Direct size-pill click handler for the inline hover strip in
     cart contexts (desktop). The PDP `related-products` section has
     its own `.related-size-btn` click handler bound to that section's
     container element, but in cart contexts (cart drawer + /cart
     page) there's no such section, so the pills used to look
     clickable and do nothing. This document-level handler adds the
     missing piece: click a size pill in a hover-strip → POST
     /cart/add.js → refresh both cart surfaces → close drawer
     popup if open. Scoped to cart contexts so the PDP handler
     still owns clicks inside the related-products section. */
  document.addEventListener('click', function (e) {
    var pill = e.target && e.target.closest && e.target.closest('.related-size-btn');
    if (!pill) return;
    if (!inCartContext(pill)) return;
    if (pill.classList.contains('unavailable')) return;
    if (pill.disabled) return;
    if (pill.classList.contains('adding')) return;
    var variantId = pill.dataset.variantId;
    if (!variantId) return;
    /* V2 — Resolve to the (activeColor, sizeLabel) variant from the
       card's full variant matrix. Without this, picking a secondary
       color and clicking a size pill on the desktop hover-strip
       added the primary color's variant. */
    var __pillCard = pill.closest('.product-recommendations-card');
    var __pillActiveSwatch = __pillCard && __pillCard.querySelector('.related-color-swatch.active');
    var __pillActiveColor = __pillActiveSwatch ? (__pillActiveSwatch.dataset.color || '').trim() : '';
    var __pillSize = (pill.textContent || '').trim();
    variantId = resolveVariantIdForColorSize(__pillCard, __pillActiveColor, __pillSize, variantId);

    e.preventDefault();
    e.stopPropagation();

    pill.classList.add('adding');
    var originalText = pill.textContent;
    pill.textContent = '…';

    /* Canonical add (fires Meta AddToCart + reconciles /cart.js + cart:change). */
    window.neswAddToCart(variantId, 1)
      .then(function () {
        pill.classList.remove('adding');
        pill.classList.add('added');
        pill.textContent = '✓';

        if (typeof window.updateCart === 'function') {
          try { window.updateCart(); } catch (_) {}
        }
        if (typeof window.refreshCartPage === 'function') {
          try { window.refreshCartPage(); } catch (_) {}
        }

        /* V2 — No auto scroll-to-top (see .cuq-add note): it blocked the
           customer from scrolling back to add more. */

        setTimeout(function () {
          pill.classList.remove('added');
          pill.textContent = originalText;
        }, 900);
      })
      .catch(function () {
        pill.classList.remove('adding');
        pill.textContent = '!';
        setTimeout(function () { pill.textContent = originalText; }, 1200);
      });
  });

  /* ──────── Tap-guard for cart upsell cards ────────
     Mirrors the home-row guard (`sections/nesw-collection-row.liquid`)
     so the same vertical-scroll → accidental-card-tap problem doesn't
     happen on cart contexts either. If the finger moves more than the
     threshold during the touch — OR if the page/drawer/track scrolls
     — the subsequent click on the card link is cancelled before the
     `<a>` follows the href.

     Stricter on the cart page (8px threshold) than the drawer (12px):
     the cart page is where the customer is actively scrolling toward
     CHECKOUT and an accidental nav to a PDP costs the most. */
  var __tgX = null, __tgY = null, __tgMax = 0, __tgStart = null, __tgScrolled = false;
  var __THRESH_DRAWER = 12;
  var __THRESH_PAGE = 8;

  function __tgNoteScroll() {
    if (__tgStart !== null) __tgScrolled = true;
  }
  window.addEventListener('scroll', __tgNoteScroll, { passive: true });
  /* Bind scroll on the upsell row + cart-drawer content scrollers so
     non-window scroll containers also flip the flag. */
  function __tgBindScrollables() {
    document.querySelectorAll(
      '.cart-page-upsell-wrap .related-products-scroll-container,' +
      '.cart-drawer-upsell-wrap .related-products-scroll-container,' +
      '.cart-drawer-content'
    ).forEach(function (el) {
      if (el.__tgBound) return;
      el.__tgBound = true;
      el.addEventListener('scroll', __tgNoteScroll, { passive: true });
    });
  }
  __tgBindScrollables();
  window.addEventListener('load', __tgBindScrollables);
  /* Drawer is rendered dynamically; rebind when it opens. */
  document.addEventListener('cart:change', __tgBindScrollables);

  function inUpsellContext(el) {
    return !!(el && el.closest && (
      el.closest('.cart-page-upsell-wrap') ||
      el.closest('.cart-drawer-upsell-wrap')
    ));
  }

  document.addEventListener('touchstart', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.product-recommendations-card');
    if (!card) return;
    if (!inUpsellContext(card)) return;
    if (!e.touches || !e.touches[0]) return;
    __tgX = e.touches[0].clientX;
    __tgY = e.touches[0].clientY;
    __tgMax = 0;
    __tgStart = Date.now();
    __tgScrolled = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (__tgStart === null || !e.touches || !e.touches[0]) return;
    var dx = e.touches[0].clientX - __tgX;
    var dy = e.touches[0].clientY - __tgY;
    var d = Math.sqrt(dx * dx + dy * dy);
    if (d > __tgMax) __tgMax = d;
  }, { passive: true });

  /* Capture phase so we beat the `<a>` navigation. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.product-recommendations-card');
    if (!card || !inUpsellContext(card)) {
      __tgStart = null;
      __tgScrolled = false;
      __tgMax = 0;
      return;
    }
    /* Allow clicks on interactive descendants (quick-add bag icon,
       swatches, size selector buttons). The guard ONLY cancels bare
       navigation on the card's <a> wrapper. */
    if (e.target.closest('.related-quick-add-btn, .related-color-swatch, .related-size-btn, .nesw-bookmark, button')) {
      __tgStart = null;
      __tgScrolled = false;
      __tgMax = 0;
      return;
    }
    /* Pick the per-surface threshold. Cart page = stricter. */
    var threshold = card.closest('.cart-page-upsell-wrap') ? __THRESH_PAGE : __THRESH_DRAWER;
    if (__tgStart !== null && (__tgMax > threshold || __tgScrolled)) {
      e.preventDefault();
      e.stopPropagation();
    }
    __tgStart = null;
    __tgScrolled = false;
    __tgMax = 0;
  }, true);
})();
